'use client';

import { useEffect, useState } from 'react';

import { smoothScrollTo, targetToId } from './smooth-scroll';

interface StickyMobileCtaProps {
  hourlyRate: number;
  ctaTarget?: string;
  ctaLabel?: string;
}

export function StickyMobileCta({
  hourlyRate,
  ctaTarget = '#calculator',
  ctaLabel = 'See Earnings',
}: StickyMobileCtaProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');

    if (!hero) {
      // Fallback to scroll distance if hero element not found
      function handleScroll() {
        setIsVisible(window.scrollY > 600);
      }

      window.addEventListener('scroll', handleScroll, { passive: true });

      return () => window.removeEventListener('scroll', handleScroll);
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show when hero is NOT intersecting (scrolled past it)
        if (entry) {
          setIsVisible(!entry.isIntersecting);
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(hero);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed right-0 bottom-0 left-0 z-50 px-4 py-3 transition-transform duration-300 lg:hidden ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ backgroundColor: 'var(--landing-primary)' }}
      data-test="sticky-mobile-cta"
    >
      <div className="mx-auto flex max-w-lg items-center justify-between gap-3">
        <p className="text-base font-bold text-black">
          R{String(hourlyRate)}/hr
        </p>
        <a
          href={ctaTarget}
          onClick={smoothScrollTo(targetToId(ctaTarget))}
          className="inline-flex h-12 items-center rounded-xl px-6 text-sm font-bold text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: 'var(--landing-secondary)' }}
          data-test="sticky-cta-button"
        >
          {ctaLabel}
        </a>
      </div>
    </div>
  );
}
